import React, { useState, useRef } from "react";
import { Input } from "./Input";
import { Select } from "./Select";
import { geoNames } from "../../utils/countriesGeonames";
import { handleKeyPress } from "../../utils/Helper";
import { countryCodes } from "./countryCodes";
import { useUpdateBillingAddressByBillingIdMutation } from "../../store/Billing/billingApiSlice";
import { ReactComponent as Spinner } from "../../assets/icons/spinner.svg";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getCitiesByCountryCodeAndStateName, getCountryCode, getStatesByCountryCode } from "../../utils/countriesState";
import PhoneNumberInput from "./PhoneNumberInput";
import { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";

export const EditBillingAddress = ({ data, setOpenBillingPopup, refetch, setOpenEditBillingAddressPopup, setHasAddressDataChanged,
  hasAddressDataChanged }) => {
  const houseNoRef = useRef();
  const localityRef = useRef();
  const companynameRef = useRef();
  const trnnoRef = useRef();
  const areaRef = useRef();
  const postalCodeRef = useRef();
  const cityRef = useRef();
  // const telPhoneRef = useRef();
  const [mobile, setMobile] = useState('');
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [countries, setCountries] = useState(getCountryCode());
  const [compContryCode, setCompContryCode] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const { userInfo, token } = useSelector((state) => state.auth);
  const [billingID, setBillingID] = useState();

  const [updateBillingAddressByBillingId, { isLoading, isSuccess }] =
    useUpdateBillingAddressByBillingIdMutation();
  const fetchStates = async (code) => {
    try {
      setStates([]);
      setTimeout(async () => {
        setStates(await getStatesByCountryCode(code));
      }, [0])

    } catch (error) {
    }
  };

  useEffect(() => {
    if (mobile) {
      const countryCode = parsePhoneNumber(mobile);      
      countryCode?.countryCallingCode && setCountryCode("+" + countryCode?.countryCallingCode);
    }
  }, [mobile])

  const fetchCities = async (code, stateName) => {
    try {
      // const response = await fetch(
      //   `https://secure.geonames.org/childrenJSON?geonameId=${cityGeoId}&username=teamprp`
      // );
      // const data = await response.json();
      // setCities(data.geonames);
      setCities(getCitiesByCountryCodeAndStateName(code, stateName));
    } catch (error) {
    }
  };

  const handleCountryChange = (e) => {
    const selectedCountryValue = e?.target?.value;
    setSelectedCountry(selectedCountryValue);
    setSelectedState("");
    setSelectedCity("");

    const selectedCountryData = countries.find(
      (country) => country?.countryCode === selectedCountryValue
    );

    if (selectedCountryData) {
      setCompContryCode(selectedCountryData?.countryCode);
      fetchStates(selectedCountryData?.countryCode);
    }
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;

    setSelectedState(selectedState);
    setSelectedCity("");
    setCities([]);
    if (selectedState) {
      fetchCities(selectedCountry, selectedState);
    }
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setSelectedCity(selectedCity);
  };

  useEffect(() => {
    if (data) {
      houseNoRef.current.value = data?.address_line_1;
      localityRef.current.value = data?.address_line_2;
      companynameRef.current.value = data?.companyName;
      trnnoRef.current.value = data?.trnNo;
      areaRef.current.value = data?.area;
      postalCodeRef.current.value = data?.postal_code;
      setMobile(data?.mobile);
      cityRef.current.value = data?.city;
      setCountryCode(data?.country_code);
      setSelectedCountry(data?.country);
      setBillingID(data?.billing_add_ID);

      const selectedCountryData = countries.find(
        (country) => country.countryCode === data?.country
      );
      if (selectedCountryData) {
        fetchStates(selectedCountryData?.countryCode);
        setSelectedState(data?.state);
        if (states) {
          fetchCities(selectedCountryData?.countryCode, data?.state);
          setSelectedCity(data?.city);
        }
      }
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};
    if (houseNoRef.current.value.trim() === "") {
      errors.houseNo = "Address Line 1 is required.";
    }

    if (cityRef.current.value === "") {
      errors.city = "City is required.";
    }

    if (selectedState.trim() === "") {
      errors.state = "State is required.";
    }

    if (selectedCountry.trim() === "") {
      errors.country = "Country is required.";
    }
    if (mobile === "" && !isPossiblePhoneNumber(mobile === "")) {
      errors.companyTel = "Enter mobile number";
    }
    if (!isPossiblePhoneNumber(mobile?.toString() ?? "")) {
      errors.companyTel = "Enter valid mobile number";
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      if (data) {
        try {
          const updateData = {
            address_line_1: houseNoRef.current.value,
            address_line_2: localityRef.current.value,
            postal_code: postalCodeRef.current.value,
            companyName: companynameRef.current.value,
            trnNo: trnnoRef.current.value,
            area: areaRef.current.value,
            country_code: countryCode,
            mobile: mobile,
            city: cityRef.current.value,
            state: selectedState,
            country: selectedCountry || compContryCode,
            type: "individual",
            billing_add_ID: billingID,
            user_id: userInfo?.individual[0]?.individualID,
          };
          let updatebilling = await updateBillingAddressByBillingId({data:updateData, token});
          if (updatebilling) {
            // window.location.reload();
            refetch();
            setHasAddressDataChanged(!hasAddressDataChanged)
            setOpenBillingPopup(true);
            setOpenEditBillingAddressPopup(!setOpenEditBillingAddressPopup)
          }
        } catch (error) {
          setApiError(
            error?.data
              ? Object.values(error?.data)[0]
              : "An error occurred. Please try again later."
          );
        }
      }
    }
  };
  return (
    <section className="relative px-4 sm:px-0  lg:py-0 overflow-hidden">
      <div className="flex -mx-4 xl:items-center items-center max-h-screen">
        <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
          <div style={{ width: "730px" }} className="mx-auto ">
            <h3 className="text-f24 text-primary font-bold mb-12 text-left">
              Edit Billing Address
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-12">
                <div className="flex gap-4 w-full h-[80px]">
                  <Input
                    label="Company Name"
                    id="companyName"
                    inputRef={companynameRef}
                    error={errors.companyName}
                    placeholder="Enter Company Name"
                  />

                  <Input
                    label="Tax Registration Number"
                    id="trnNo"
                    inputRef={trnnoRef}
                    error={errors.trnNo}
                    placeholder="Enter Tax Registration Number"
                  />
                </div>
                <div className="flex gap-4 w-full h-[80px]">
                  <Input
                    label="Address"
                    id="houseNo"
                    inputRef={houseNoRef}
                    error={errors.houseNo}
                    placeholder="Suite/Building/Floor No."
                  />

                  <Input
                    label="Area"
                    id="locality"
                    inputRef={localityRef}
                    error={errors.locality}
                    placeholder="Enter Area"
                  />
                </div>
                <div className="flex gap-4 w-full h-[80px]">
                  <div className="w-full">
                    <label
                      htmlFor="country"
                      className="block mb-1 text-primary text-f14 font-semibold text-left"
                    >
                      Country
                    </label>
                    <Select
                      id="country"
                      placeholder="Select a country"
                      value={selectedCountry}
                      onChange={handleCountryChange}
                      className={`w-full border ${errors.country ? "border-red-500" : "border-input"
                        } focus:border-primary px-3 py-2 border border-input rounded bg-inputDisable outline-none text-primary`}
                    >
                      <option value="">Select a country</option>
                      {countries?.map((country) => (
                        <option
                          key={country.countryName}
                          value={country.countryCode}
                        >
                          {country.countryName}
                        </option>
                      ))}
                    </Select>
                    {errors.country && (
                      <p className="text-red-500 text-sm text-left">
                        {errors.country}
                      </p>
                    )}
                  </div>
                  {states?.length > 0 ? <Select
                    label="State"
                    id="state"
                    classes="w-full text-left"
                    value={selectedState}
                    onChange={handleStateChange}
                    error={errors.state}
                    placeholder="Select a state"
                  >
                    <option value="">Select a state</option>
                    {states?.map((state) => (
                      <option key={state.state_code} value={state.name}>
                        {state.name}
                      </option>
                    ))}
                  </Select> :
                    <Input
                      label="State"
                      id="state"
                      value={selectedState}
                      onInputChange={handleStateChange}
                      error={errors.state}
                      placeholder="Enter a state"
                      disable={!selectedCountry}
                      className={!selectedCountry ? "cursor-not-allowed" : "default"}
                    />}

                </div>
                <div className="flex gap-4 w-full h-[80px]">
                  <Input
                    label="City"
                    id="city"
                    inputRef={cityRef}
                    error={errors.city}
                    placeholder="Enter City"
                  />
                  <Input
                    label="Landmark"
                    id="area"
                    inputRef={areaRef}
                    error={errors.area}
                    placeholder="Enter Landmark"
                  />
                </div>
                <div className="flex gap-4 w-full h-[80px]">
                  <Input
                    label="Postal Code"
                    id="postalCode"
                    inputRef={postalCodeRef}
                    error={errors.postcode}
                    placeholder="Enter Postal Code"
                  />                  <div className="flex items-start flex-col">
                    <div className="flex items-start flex-col w-full gap-1">
                      <label className="text-primary text-f14 font-semibold">
                        Mobile Number
                      </label>
                      <div
                        style={{ width: "357px" }}
                        className="relative w-full"
                      >
                        <PhoneNumberInput
                          id="mobile"
                          phone={mobile}
                          border={true}
                          setPhone={setMobile}
                          verifyPhoneNumber={false}
                          classes={'addBackground'}
                        />
                        <p class="text-red-500 text-sm text-left">{errors.mobile}</p>
                      </div>
                      {errors.companyTel && (
                        <p className="text-red-500 text-sm text-left">
                          {errors.companyTel}
                        </p>
                      )}
                    </div>
                    {apiError && (
                      <p className="text-red-500 text-sm text-left">
                        {apiError}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {apiError && (
                <div className="text-left text-red-500 mb-5">{apiError}</div>
              )}
              <div className="flex justify-between gap-2">
                <button
                  className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `}
                  type="submit"
                >
                  <span className="relative">
                    {isLoading ? <Spinner /> : "Save Changes"}
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
